<template>
    <div>
        <div class="form-horizontal" encregion="multipart/form-data" @submit.prevent="store"
             @keydown="form.errors.clear($event.target.name)">
            <table class="table table-striped">
                <tr>
                    <th>{{ uLang('app.name') }}</th>
                    <th>{{ uLang('app.action') }}</th>
                </tr>
                <tr v-for="websiteTargetAudience in websiteTargetAudiences">
                    <td>
                        <input type="text" v-if="websiteTargetAudience.editable" class="form-control"
                               :name="websiteTargetAudience.value" v-model="form['value'][websiteTargetAudience.id]">
                        <span v-if="!websiteTargetAudience.editable">{{ websiteTargetAudience.value }}</span>
                    </td>
                    <td>
                        <a href="#" @click.prevent="removeWebsiteTargetAudience(websiteTargetAudience)"
                           class="btn btn-danger" v-if="websiteTargetAudience.deleteable"
                           :title="uLang('app.delete_website_target_audience')">
                            <i class="fa fa-trash"></i>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" name="new" v-model="newWebsiteTargetAudience"
                           :placeholder="uLang('app.new_website_target_audience')"
                           :title="uLang('app.add_new_website_target_audience')">
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-success" @click="addWebsiteTargetAudience"
                                :disabled="form.busy">{{
                                uLang('app.create_entity', {entity: lang('app.website_target_audience')})
                            }}</button>
                    </span>
                </div>
            </div>

            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()"
                       class="btn btn-brand"/>
            </div>
        </div>
    </div>
</template>

<script>
import Form from '~/Form/Form'
import {ErrorAlert, SuccessAlert, DestroyAlert} from '~/Swals'
import {AlphabeticalSort} from '~/mixins'

export default {
    props: {
        settingId: {
            required: true,
        },
    },
    mixins: [
        AlphabeticalSort
    ],
    data() {
        return {
            form: new Form({
                value: {},
            }),
            newWebsiteTargetAudience: '',
            websiteTargetAudiences: []
        }
    },
    mounted: function () {
        this.retrieveValues();
    },
    methods: {
        async store() {
            this.form['patch']('/api/admin/settings/' + this.settingId)
                .then(response => {
                    this.setValues(response);
                    new SuccessAlert({text: this.uLang('app.entity_updated', {entity: lang('app.website_target_audiences')})}).show();
                })
                .catch(error => {
                    new ErrorAlert({
                        title: uLang('app.oops_something_went_wrong'),
                        text: uLang('app.all_inputs_need_to_be_filled'),
                    }).show();
                });
        },

        setValues(data) {
            data = this.alphabeticalSort(data)

            this.form.value = {};

            this.websiteTargetAudiences = data;

            data.forEach(function (websiteTargetAudience) {
                if (websiteTargetAudience.editable) {
                    this.value[websiteTargetAudience.id] = websiteTargetAudience.value;
                }

            }, this.form);

        },

        async retrieveValues() {
            // TODO: Check if this basic setting logic happens in other components, and maybe move to mixin
            const {data} = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

            this.setValues(data);
        },

        addWebsiteTargetAudience() {
            if (this.newWebsiteTargetAudience === '')
                return;


            this.websiteTargetAudiences.push(
                {
                    id: this.newWebsiteTargetAudience,
                    value: this.newWebsiteTargetAudience,
                    deleteable: 1,
                    editable: 1
                }
            );
            this.form.value[this.newWebsiteTargetAudience] = this.newWebsiteTargetAudience;
            this.newWebsiteTargetAudience = '';
        },

        removeWebsiteTargetAudience(websiteTargetAudience) {
            new DestroyAlert({entity: this.lang('app.website_target_audience')}).show().then(async () => {

                delete this.form.value[websiteTargetAudience.id];

                //remove the websiteTargetAudience from the table
                this.websiteTargetAudiences = this.websiteTargetAudiences.filter(function (current_website_target_audience) {
                    return current_website_target_audience.value != websiteTargetAudience.value;
                });
            })
        }
    }
}
</script>

<style lang="css" scoped>

</style>
